module.exports = __webpack_public_path__ + "static/media/bg2.a4e6a77f.png";